import * as Yup from "yup";
import { useTranslation } from "react-i18next";

const useLoginSchema = () => {
  const { t } = useTranslation();
  return Yup.object().shape({
    phoneNumber: Yup.string()
      .required(t("required_phone_number"))
      .min(9, t("phonenumber_min_length"))
      .max(10, t("phonenumber_max_length")),
    password: Yup.string()
      .min(8, t("min_password"))
      .required(t("required_password")),
  });
};

export default useLoginSchema;
